import { Component, input } from '@angular/core';

@Component({
  selector: 'lp-inventory-item-preview',
  imports: [],
  templateUrl: './lp-inventory-item-preview.component.html',
  styleUrl: './lp-inventory-item-preview.component.css',
})
export class LpInventoryItemPreviewComponent {
  name = input.required<string>();
  icon = input.required<string>();
}
